module.exports = __webpack_public_path__ + "assets/img/banner2.56663f79.png";